import { WAITING_LIST_ACTION, BOOKING_ACTION } from "../actions";

const INITIAL_STATE = {
  required: false,
  preferredTime: ""
};

export const waitingListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WAITING_LIST_ACTION.REQUIRE_WAITING_LIST:
      return { ...state, required: action.payload.required };

    case WAITING_LIST_ACTION.UPDATE_PREFERRED_TIME:
      return { ...state, preferredTime: action.payload.time };

    case BOOKING_ACTION.GO_BACK_TO_STEP:
      return INITIAL_STATE;

    case BOOKING_ACTION.MAKE_NEW_BOOKING:
      return INITIAL_STATE;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/reducers/waitingListReducer.js